import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { NumericFormat, numericFormatter, } from 'react-number-format';
import { TextField } from '../TextField';
export const formatCurrency = (amount) => numericFormatter(amount, {
    decimalSeparator: ',',
    thousandSeparator: '.',
    decimalScale: 2,
    fixedDecimalScale: true,
});
export const CurrencyField = forwardRef(function CurrencyField({ onChange, onBlur, value, decimalScale, ...props }, ref) {
    return (_jsx(NumericFormat, { customInput: TextField, ...props, value: value, getInputRef: ref, onValueChange: (values) => onChange?.(values.floatValue ?? null), decimalSeparator: ",", thousandSeparator: ".", valueIsNumericString: true, allowNegative: false, decimalScale: decimalScale ?? 2, fixedDecimalScale: true, onFocus: (e) => {
            if (value === 0) {
                e.target.setSelectionRange(0, (decimalScale ?? 2) + 2);
            }
        }, onBlur: () => {
            if (onBlur)
                onBlur(value ?? 0);
        } }));
});
